import { inputClasses } from '@private/components';
import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Typography from '../../Typography';
import Input from '../Input';

const prefix = ['components', 'periodInputs'];
export const Label = styled(Typography)`
  min-height: 20px;
  color: ${getPrefixedVar(prefix, 'label')};
  margin-bottom: 4px;
`;

export const TimeFields = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
`;

export const FieldColumn = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: 6px;
`;

export const HintText = styled(Typography)`
  white-space: nowrap;
  color: ${getPrefixedVar(prefix, 'hint')};
  margin-bottom: 6px;
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

export const HintButtonContainer = styled.div`
  margin-bottom: 4px;
`;

export const StyledInput = styled(Input)`
  ${inputClasses.input} {
    padding: 0 8px;
  }
`;
